export default {
  'Comparison.title': 'Сравнение',
  'Comparison.noData': 'Вы не добавили ни одного продукта',
  'Comparison.noTopics': 'Недостаточно тем',
  'Comparison.chooseMoreTopics': 'Выберите другие продукты',
  'Comparison.chooseButton': 'Выбрать продукты',
  'Comparison.chooseTopics': 'Выбрать темы',
  'Comparison.clearAll': 'Очистить',
}
